// extracted by mini-css-extract-plugin
module.exports = {"countdownTime":"countdownTime__2jsyD","countdownVideoContainer":"countdownVideoContainer__3bxaa"};